import { useState, useEffect } from 'react';

interface ScreenSize {
  isMobile: boolean;
}

export function useScreenSize(): ScreenSize {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      // Tailwind's default 'sm' breakpoint is 640px
      setIsMobile(window.innerWidth < 640);
    };

    // Check on mount
    checkScreenSize();

    // Add resize listener
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return { isMobile };
}
